
export class AsignacionDispositivoDto {
  cantidad: number;
  nombre: string;
  idVlan: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/asignacion-dispositivos.ts